/**
 * Created with IntelliJ IDEA.
 * User: talf
 * Date: 7/29/13
 * Time: 2:23 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {

    window.lpTag = window.lpTag || {};

    var lpUtils = require('utils/lpUtils');
    var TableViewController = require('web-agent-framework/TableViewController');
    var countries = require('web-agent-utils/CountryCodes');
    var ViewController = require('web-agent-framework/ViewController');

    var VisitorInfoViewController = ViewController.extend({

        ControllerName: 'VisitorInfoViewController',

        LPViewMap: {
            customVariablesTable: ".lpview_custom_variables_table",
            visitorInfoTable: ".lpview_rows_table",
            pageNavigationTable: ".lpview_page_navigation_table",
            pageNavigationWrapper: ".lpview_navigation_history",
            pageNavigationItems: ".lpview_page_history_items"
        },

        initialize: function (constructorData) {
            this.visitorInfoRowsObjects = {};
            this.additionalVisitorInfoRowsArray = [];
            this.countryNames = {};
            this.geoStates = {};

            this.visitorInfoPropertiesArray = [
                "contactID",
                "geoCountry",
                "country",
                "geoCity",
                "geoOrg",
                "skill",
                "state",
                "email",
                "os",
                "operatingSystem",
                "browser",
                "sso",
                "ip",
                "ipAddress",
                "referrer",
                "engagementStartTime",
                "visitStartTime",
                "geoTimeZone"
            ];

            this.excludedVisitorInfoParametersArray = [
                "API Application Name",
                "LPContainerId",
                "LP visitor category",
                "API Application Key",
                "engagementSequence",
                "agentDeleted"
            ];

            this.visitorInfoRowsPriorityMap = this.createPriorityMapFromArray(this.visitorInfoPropertiesArray);

            this.visitorInfoTable = new TableViewController({
                modelController: this.modelController,
                rowTemplateFile: "LP_visitor_info_row.html",
                dataRenderer: this.visitorInfoDataRenderer,
                context: this
            });
            this.addViewController({viewController : this.visitorInfoTable, target : this.LPViewMap.visitorInfoTable});

            this.customVariablesTable = new TableViewController({
                modelController: this.modelController,
                rowTemplateFile: "LP_visitor_info_row.html",
                dataRenderer: this.customVariablesDataRenderer,
                context: this
            });
            this.addViewController({viewController : this.customVariablesTable, target : this.LPViewMap.customVariablesTable});

            this.pageNavigationTable = new TableViewController({
                modelController: this.modelController,
                rowTemplateFile: "LP_visitor_info_link_content.html",
                dataRenderer: this.pageNavigationDataRenderer,
                context: this
            });
            this.addViewController({viewController : this.pageNavigationTable, target : this.LPViewMap.pageNavigationItems});
        },

        events: function () {
            this.bindModel({modelPath : "participants." + this.participantPath + this.currentVisitorId + ".participantInfo", callback : this.updateVisitorInfoItems});
        },

        render: function () {
        }
    });

    VisitorInfoViewController.prototype.visitorInfoDataRenderer = {
        numberOfRowsInSection: function (data) {
            return data.length;
        },

        dataForRowInSection: function (data, rowIndex) {
            var rowData = data[rowIndex];
            var value = {text: "", details: "", rowData: rowData};
            var text = this.translate(this.ControllerName + "_" + rowData.tag);
            value.text = lpUtils.escapeHTML(text);
            value.details = rowData.value;
            if (rowData.tag === "country" || rowData.tag === "geoCountry" || rowData.tag === "referrer") {
                value.ignoreEscapeHTML = true;
            }
            value.detailsTooltip = rowData.value || "";
            return value;
        }
    };

    VisitorInfoViewController.prototype.customVariablesDataRenderer = {
        numberOfRowsInSection: function (data) {
            return data.length;
        },
        dataForRowInSection: function (data, rowIndex) {
            var rowData = data[rowIndex];
            var value;
            var source = rowData["@source"] || rowData.source;
            // excluding this custom vars since they are created every time the visitor is navigating in the
            // site and we already see this information in the navigation history
            if ((source === "monitortag" && rowData.displayName === "visitorActive") ||
                this.nameInExcludedVisitorInfoParametersArray(rowData.displayName)) {
                return;
            } else {
                var text = this.translate(this.ControllerName + "_" + rowData.displayName);
                if (!this.isTranslated(this.ControllerName + "_" + rowData.displayName, text)) {
                    text = rowData.displayName || rowData.name;
                }
                text = text.replace(/_/g, ' ');
                value = {text : text, details : rowData.value, rowData : rowData, detailsTooltip : rowData.value || ""};
            }
            return value;
        }
    };

    VisitorInfoViewController.prototype.nameInExcludedVisitorInfoParametersArray = function (name) {
        for (var i = 0; i < this.excludedVisitorInfoParametersArray.length; i++) {
            if (this.excludedVisitorInfoParametersArray[i] === name) {
                return true;
            }
        }
        return false;
    };

    VisitorInfoViewController.prototype.pageNavigationDataRenderer = {
        numberOfRowsInSection: function (data) {
            return data.length;
        },

        dataForRowInSection: function (data, rowIndex) {
            var rowData = data[rowIndex];
            var value = this.createLinkForInfoItem(rowData);
            value.rowData = rowData;
            switch (rowIndex) {
                case 0 :
                    value.text = this.translate(this.ControllerName + "_currentPage"); break;
                case 1 :
                    value.text = this.translate(this.ControllerName + "_previousPages"); break;
                default :
                    break;
            }

            // toggle show/hide of sections container
            // using empty string as fallback to guard from translation in the template of undefined value
            value.hideSectionsClassName = value.sections ? "" : "hidden";

            return value;
        }
    };

    VisitorInfoViewController.prototype.updateVisitorId = function (visitorId, participantPath) {
        if (this.currentVisitorId) {
            delete this.geoStates[this.currentVisitorId];
            delete this.countryNames[this.currentVisitorId];
        }
        this.participantPath = participantPath || "myEngagements.";
        this.pageNavigationTable.updateModelData([]);

        if (typeof this.participantPath == 'undefined') {
            this.logger.error("Unable to updateVisitorId, visitor does not exist", "updateVisitorId");
            return;
        }

        if (this.currentVisitorId) {
            this.unbindModel({modelPath: "participants." + this.previousParticipantPath + this.currentVisitorId + ".participantInfo"});
            this.unbindModel({modelPath: "participants." + this.previousParticipantPath + this.currentVisitorId + ".participantTag"});
            this.visitorInfoRowsObjects = {};
        }

        this.currentVisitorId = visitorId;
        this.customVariablesTable.updateModelPath("participants." + this.participantPath + this.currentVisitorId + ".participantInfo.customVariables");
        this.bindModel({modelPath : "participants." + this.participantPath + this.currentVisitorId + ".participantInfo", callback : this.updateVisitorInfoItems});
        this.bindModel({modelPath : "participants." + this.participantPath + this.currentVisitorId + ".participantTag", callback : this.participantTagChanged});

        this.previousParticipantPath = this.participantPath;
    };

    VisitorInfoViewController.prototype.updateVisitorInfoItems = function (data) {
        if (typeof data.newValue === "undefined") {
            return;
        }
        for (var infoItemTag in data.newValue) {
            if (data.newValue.hasOwnProperty(infoItemTag)) {
                var value = data.newValue[infoItemTag];
                switch (infoItemTag) {
                    case "chatHistory" : break;
                    case "currentPage" : break;
                    case "customVariables" : break;
                    case "pages" : this.addNavigationHistoryInfoItems(data.newValue.pages); break;
                    case "state" : this.addVisitorInfoItem(infoItemTag, this.translate("STATE_" + data.newValue[infoItemTag])); break;
                    case "geoCountry" : this.addVisitorInfoItem(infoItemTag, this.addCountryFlag(value, data.newValue)); break;
                    case "country" : this.addVisitorInfoItem(infoItemTag, this.addCountryFlag(value, data.newValue)); break;
                    case "geoState" : var country = this.addGeoState(value, data.newValue); if (country) {this.addVisitorInfoItem(infoItemTag, country);} break;
                    case "engagementStartTime" : this.addVisitorInfoItem(infoItemTag, lpUtils.formatDateAsString(lpUtils.createDate(value, lpUtils.FORMAT_TYPES.ENGAGEMENT_WINDOW)));  break;
                    case "visitStartTime" : this.addVisitorInfoItem(infoItemTag, lpUtils.formatDateAsString(lpUtils.createDate(value, lpUtils.FORMAT_TYPES.ENGAGEMENT_WINDOW)));  break;
                    case "referrer" : this.addVisitorInfoItem(infoItemTag, this.addReferrerLink(value)); break;
                    default : this.addVisitorInfoItem(infoItemTag, value); break;
                }
            }
        }
        var primaryResultArray = this.getModelDataAsPriorityArray(this.visitorInfoRowsObjects);
        this.visitorInfoTable.updateModelData(primaryResultArray);
//    this.visitorInfoTable.updateModelData(primaryResultArray.concat(this.additionalVisitorInfoRowsArray));
    };

    VisitorInfoViewController.prototype.addVisitorInfoItem = function (infoItemTag, value) {
        if (value){
            if (typeof this.visitorInfoRowsPriorityMap[infoItemTag] !== "undefined") {
                var infoItemIndex = this.visitorInfoRowsPriorityMap[infoItemTag];
                this.visitorInfoRowsObjects[infoItemIndex] = {tag : infoItemTag, value : value};
            } else {
                this.additionalVisitorInfoRowsArray.push({tag : infoItemTag, value : value});
            }
        }
    };

    VisitorInfoViewController.prototype.addNavigationHistoryInfoItems = function (pages) {
        this.pageNavigationTable.updateModelData(pages);
        if (pages.length) {
            this.lpShow(this.LPViewMap.pageNavigationTable);
        }
    };

    VisitorInfoViewController.prototype.participantTagChanged = function (data) {
        if (!data.newValue) {
            return;
        }
        if (this.color) {
            this.removeClass(this.LPViewMap.pageNavigationTable, this.color);
            this.removeClass(this.LPViewMap.visitorInfoTable, this.color);
        }
        this.color = data.newValue;
        this.addClass(this.LPViewMap.pageNavigationTable, this.color);
        this.addClass(this.LPViewMap.visitorInfoTable, this.color);
    };

    VisitorInfoViewController.prototype.createPriorityMapFromArray = function (infoItemsArray) {
        var result = {};
        result.length = infoItemsArray.length;
        for (var i = 0; i < infoItemsArray.length; i++) {
            result[infoItemsArray[i]] = i;
        }
        return result;
    };

    VisitorInfoViewController.prototype.getModelDataAsPriorityArray = function (modelData) {
        var resultArray = [];
        for (var i = 0; i < this.visitorInfoPropertiesArray.length; i++) {
            if (modelData[i]) {
                resultArray.push(modelData[i]);
            }
        }
        return resultArray;
    };

    VisitorInfoViewController.prototype.addGeoState = function (geoState, data) {
        var result = null;
        if (this.countryNames[this.currentVisitorId]) {
            // Making sure the data will contain the geoState
            data.geoState = geoState;
            result = this.addCountryFlag(this.countryNames[this.currentVisitorId], data);
        } else {
            // If we don't have a country name - saving the geoState for when the country name arrives
            this.geoStates[this.currentVisitorId] = geoState;
        }
        return result;
    };

    VisitorInfoViewController.prototype.addCountryFlag = function (countryName, data) {
        if (countryName) {
            var result;
            var flagTemplate = require("web-agent-templates/LP_country_flag.html");
            // var flagTemplate = lpUtils.loadResource("web-agent-templates/LP_country_flag.html");
            var countryCode = countries[countryName.toUpperCase()];
            if (countryCode) {
                flagTemplate = this.injectTextDefaults(flagTemplate, {country: countryCode.toLowerCase()});
                result = flagTemplate + " ";
                var stateName = 'geoState';
                if (data && data.hasOwnProperty(stateName)) {
                    result = result + data[stateName] + ', ';
                } else if (this.geoStates[this.currentVisitorId]) {
                    result = result + this.geoStates[this.currentVisitorId] + ', ';
                } else {
                    // If we don't have a geoState - saving the country name for when the geoState arrives
                    this.countryNames[this.currentVisitorId] = countryName;
                }
                result = result + countryName;
                return result;
            }
        }
    };

    VisitorInfoViewController.prototype.addReferrerLink = function (referrerValue) {
        if (referrerValue) {
            var flagTemplate = require("web-agent-templates/LP_referrer.html");
            // var flagTemplate = lpUtils.loadResource("web-agent-templates/LP_referrer.html");
            flagTemplate = this.injectTextDefaults(flagTemplate, {href: referrerValue, color: this.color});
            return flagTemplate;
        }
    };

    VisitorInfoViewController.prototype.createLinkForInfoItem = function (data) {
        var linkForInfoItem = {};

        linkForInfoItem.title = data.title || data.pageTitle || "";
        linkForInfoItem.url = data.url || data.pageUrl || "";
        linkForInfoItem.time = data.time || parseInt(data.pageLastAccessTime, 10);
        if (!linkForInfoItem.title) {
            linkForInfoItem.title = this.translate("pageHasNoTitle");
        } else {
            linkForInfoItem.title = linkForInfoItem.title;
        }
        if (linkForInfoItem.time) {
            linkForInfoItem.time = this.formatTime(linkForInfoItem.time, false);
        }

        var urlForNavigation;
        if (data.link) {
            urlForNavigation = data.link.constructor === Array ? data.link[1]['@href'] : data.link.href;
        } else {
            urlForNavigation = linkForInfoItem.url;
        }
        linkForInfoItem.href = urlForNavigation;

        return linkForInfoItem;
    };

    return VisitorInfoViewController;

});
